import {useEffect} from "react";

import {controllerConectaPro} from "../../../../services/controllers/service-activation";
import {NewUser} from "./new-user";
import {UserList} from "./user-list";


export function ConectaPro(){
  const CLConectaPro = controllerConectaPro()

  useEffect(()=>{
    CLConectaPro.getUsers()
  },[])

  return(
    <div className="flex flex-col gap-6 w-full">
      <NewUser />
      <UserList />
    </div>
  )
}
